import { defineMessages } from 'react-intl'

import { LOST_TYPE } from './constants'

export const lostTypeMessages = defineMessages({
  [LOST_TYPE.ADMINISTRATIVE_ERROR]: {
    id: 'spanish.items.lost.type.administrativeError',
    defaultMessage: 'Error administrativo'
  },
  [LOST_TYPE.OPERATIVE_WASTE]: {
    id: 'spanish.items.lost.type.operativeWaste',
    defaultMessage: 'Merma operativa'
  },
  [LOST_TYPE.EXPIRED]: {
    id: 'spanish.items.lost.type.naturalWaste',
    defaultMessage: 'Merma natural'
  },
  [LOST_TYPE.ACCIDENT]: {
    id: 'spanish.items.lost.type.accident',
    defaultMessage: 'Accidente'
  },
  [LOST_TYPE.RETURN]: {
    id: 'spanish.items.lost.type.return',
    defaultMessage: 'Devolución del cliente'
  }
})
